import plJobOffer from "./i18n/jobOffer.pl.json";

/**
 * Minimal drop-in replacement for react-i18next's `useTranslation`, scoped to the
 * job-offer / recruitment form.
 *
 * The admin app (react/) has no i18n runtime and is Polish-only, but the
 * job-offer form components are ported verbatim from the client app
 * (cyberjob_client/) so the two forms stay 1:1. Rather than hand-inlining ~750
 * strings (which would guarantee drift), this shim feeds those components the
 * Polish copy straight from the bundled `pl/jobOffer.json`.
 *
 * Supported subset of the i18next `t` contract actually used by the form:
 *   t("a.b.c")                     -> nested lookup
 *   t("a.b", "Fallback")           -> string default value
 *   t("a.b", { x: 1 })             -> "{{x}}" interpolation
 *   t("a.b", { returnObjects: true }) -> return the raw array/object node
 */

const DICTS = { jobOffer: plJobOffer };

const resolve = (dict, key) =>
    key.split(".").reduce((node, part) => (node == null ? undefined : node[part]), dict);

const interpolate = (str, vars) =>
    str.replace(/\{\{\s*([\w.]+)\s*\}\}/g, (match, name) =>
        vars[name] != null ? String(vars[name]) : match
    );

export function useTranslation(ns = "jobOffer") {
    const dict = DICTS[ns] ?? {};
    const t = (key, opts) => {
        const defaultValue = typeof opts === "string" ? opts : undefined;
        const options = opts && typeof opts === "object" ? opts : {};
        const value = resolve(dict, key);
        if (value === undefined) return defaultValue ?? key;
        if (options.returnObjects) return value;
        if (typeof value === "string") return interpolate(value, options);
        return value;
    };
    return { t, i18n: { language: "pl", changeLanguage: () => {} } };
}

export default { useTranslation };
